var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('store-recherche-provider',{key:"listeFactures",attrs:{"name":_vm.constantes.storeName,"copy":_vm.factureStore}},[_c('liste-factures',{attrs:{"nameStore":_vm.constantes.storeName,"referenceTable":_vm.constantes.referenceTable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }